/**
 * Promise that takes a delay in ms and resolves right after this delay
 * @param delay - Delay in ms
 */
export function sleep(delay: number): Promise<void> {
  return new Promise(resolve => setTimeout(resolve, delay));
}
